import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { assignmentDelete } from '../../redux/actions/assignments';

const DeleteSupplierAssignmentModal = ({ payload, supplier, modalProductId, modalVariationId, modalOptions, modalProductName, modalAssignment, showDeleteSupplierAssignmentModal, setShowDeleteSupplierAssignmentModal, deleteAssignment, accountUnits, modalY }) => {
  const update = () => {
    let assignment = {
      product_id: modalProductId,
      variation_id: modalVariationId
    }

    deleteAssignment(payload, supplier.id, assignment);
    setShowDeleteSupplierAssignmentModal(false);
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, position: 'fixed' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowDeleteSupplierAssignmentModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3><strong>Supplier</strong>: { supplier.supplier_name }</h3>
            <h3><strong>Product</strong>: {modalProductName}</h3>

            { modalOptions && modalOptions.map(option =>
                <li>
                  <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                </li>
              )
            }

            Current Supplier SKU: {modalAssignment.supplier_sku}<br/>
            Current Supplier Price: {modalAssignment.supplier_price ?  format(modalAssignment.supplier_price) : ''}<br/>
            Current MOQ: {modalAssignment.minimum_order}

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Delete Assignment</button>
          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = state => ({ 
  accountUnits: state.accounts.account.store_details.formatsAndUnits,

});

const mapDispatchToProps = (dispatch) => ({
  deleteAssignment: (payload, supplierId, assignment) => dispatch(assignmentDelete(payload, supplierId, assignment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSupplierAssignmentModal);